export default __webpack_public_path__ + "static/media/lamb.46b188b9.png";